import React from "react";

const Footer = () => (
  <footer className="footer d-flex">
    <div className="container text-center text-muted justify-content-center align-self-center">
      <small>
        <span>&copy; Elrond Network</span>
      </small>
    </div>
  </footer>
);

export default Footer;
